export default "__VITE_ASSET__BTzz6Zg9__"